import { Link } from "react-router-dom";
import WhatsAppIcon from "../WhatsAppIcon";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_industrial-shields/artifacts/otud2dwa_Flexi.png";
const WA_URL =
  "https://wa.me/524424319100?text=Hola,%20necesito%20un%20diagn%C3%B3stico%20urgente%20para%20la%20guarda%20telesc%C3%B3pica%20de%20mi%20CNC";

export default function RepairHeader({
  onNavigate,
  tagline = "Reparación de guardas CNC · 24/7",
  ctaLabel = "Cotizar reparación",
  waUrl = WA_URL,
}) {
  return (
    <header
      data-testid="repair-header"
      className="fixed top-0 inset-x-0 z-50 bg-[#061226]/85 backdrop-blur-md border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link
          to="/"
          data-testid="repair-nav-logo"
          className="flex items-center gap-3 group"
          aria-label="Volver al sitio principal"
        >
          <div className="bg-white px-3 py-1.5" style={{ borderRadius: "2px" }}>
            <img src={LOGO_URL} alt="Guarda Flex" className="h-9 w-auto" />
          </div>
          <span className="hidden sm:inline font-display font-black text-lg tracking-tight leading-none">
            <span className="text-white">GUARDA</span>
            <span className="text-slate-400"> FLEX</span>
          </span>
        </Link>

        <span className="hidden md:inline font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#00B4D8]">
          {tagline}
        </span>

        <div className="flex items-center gap-3">
          <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="repair-nav-whatsapp"
            aria-label="WhatsApp diagnóstico urgente"
            className="w-10 h-10 border border-[#25D366]/50 text-[#25D366] flex items-center justify-center hover:bg-[#25D366] hover:text-white transition-colors"
            style={{ borderRadius: "2px" }}
          >
            <WhatsAppIcon size={18} className="text-current" />
          </a>
          <button
            onClick={() => onNavigate("cotizar")}
            data-testid="repair-nav-cotizar"
            className="gf-btn-primary !py-2.5 !px-5 text-xs"
          >
            {ctaLabel}
          </button>
        </div>
      </div>
    </header>
  );
}
